<template>
    <modal name="coupon-member-list-modal" class="popup-banner-modal"
           :width="'500px'"
           :height="'auto'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
      <div class="list-content pa15">
        <div class="title pl25 pt20" style="display: inline-block;">회원리스트</div>
        <div class="btn_wrap text-center mt20" style="display: inline-block; float: right;">
            <el-button class="mr25" type="cancel" @click="close()">닫기</el-button>
        </div>
        <div class="pl30 pr30 pb15 pt30">
            <member-list-coupon-modal-component :member-type="'memberCoupon'"></member-list-coupon-modal-component>            
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  
  import util from "@/mixins/util";
import MemberListCouponModalComponent from "@/components/member/MemberListCouponModalComponent"
  
  import EventBus from "@/utils/event-bus";
  import alertMixins from "@/mixins/alertMixins";
  
  export default {
    name: "CouponMemberListModal",
    mixins: [alertMixins],
    components: {
        MemberListCouponModalComponent
    },
    props: {
    },
    data() {
      return {
      }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{
      handlerBeforeOpen(event) {
      },
      handlerOpened() {
      },
      handlerBeforeClose() {
      },
      close(){
        this.$modal.hide('coupon-member-list-modal');

      },
    },
    watch: {
  
    },
  }
  </script>
  
  <style scoped>
  
  </style>
  